// extracted by mini-css-extract-plugin
export default {"polaroid":"PolaroidPhoto_polaroid__B7O-X","image":"PolaroidPhoto_image__Zyiep","caption":"PolaroidPhoto_caption__PxzDG"};